<template>
  <div class="demo_wrap">
    <div class="demo_title_wrap">
      <h1>{{ $t('demo.title') }}</h1>
      <p>
        {{ $t('demo.subtitle') }}
      </p>
    </div>
    <div class="demo_form hidden-xs-only">
      <Form
        :model="formTop"
        label-position="top"
        inline
        class="demo_form_item1"
      >
        <FormItem
          :label="$t('demo.form.serviceLabel')"
          style="width: 46%"
          class="form_item1"
          required
        >
          <Select v-model="formTop.service" :placeholder="$t('demo.form.servicePlaceholder')" size="large">
            <Option value="auditPlatform">{{ $t('demo.form.services.auditPlatform') }}</Option>
            <Option value="complianceManagement">{{ $t('demo.form.services.complianceManagement') }}</Option>
            <Option value="riskAssessment">{{ $t('demo.form.services.riskAssessment') }}</Option>
            <Option value="auditConsulting">{{ $t('demo.form.services.auditConsulting') }}</Option>
          </Select>
        </FormItem>
        <FormItem :label="$t('demo.form.nameLabel')" style="width: 46%" class="form_item1" required>
          <Input
            v-model="formTop.input"
            :placeholder="$t('demo.form.namePlaceholder')"
            size="large"
          ></Input>
        </FormItem>
      </Form>
      <Form
        :model="formTop2"
        label-position="top"
        inline
        class="demo_form_item2"
      >
        <FormItem :label="$t('demo.form.phoneLabel')" style="width: 23%" class="form_item2" required>
          <Input
            v-model="formTop2.phone"
            :placeholder="$t('demo.form.phonePlaceholder')"
            size="large"
          ></Input>
        </FormItem>
        <FormItem :label="$t('demo.form.codeLabel')" style="width: 22%" class="form_item2" required>
          <Input
            v-model="formTop2.code"
            :placeholder="$t('demo.form.codePlaceholder')"
            search
            :enter-button="$t('demo.form.getCodeButton')"
            size="large"
          ></Input>
        </FormItem>
        <FormItem :label="$t('demo.form.emailLabel')" style="width: 46%" class="form_item2" required>
          <Input
            v-model="formTop2.email"
            :placeholder="$t('demo.form.emailPlaceholder')"
            size="large"
          ></Input>
        </FormItem>
      </Form>
      <Form
        :model="formTop3"
        label-position="top"
        inline
        class="demo_form_item2"
      >
        <FormItem
          :label="$t('demo.form.companyLabel')"
          style="width: 46%"
          class="form_item3"
          required
        >
          <Input
            v-model="formTop3.gongsi"
            :placeholder="$t('demo.form.companyPlaceholder')"
            size="large"
          ></Input>
        </FormItem>
        <FormItem :label="$t('demo.form.positionLabel')" style="width: 46%" class="form_item3">
          <Input
            v-model="formTop3.zhiwu"
            :placeholder="$t('demo.form.positionPlaceholder')"
            size="large"
          ></Input>
        </FormItem>
        <FormItem :label="$t('demo.form.remarksLabel')" style="width: 92%" class="form_item3">
          <Input
            v-model="formTop3.beizhu"
            :placeholder="$t('demo.form.remarksPlaceholder')"
            type="textarea"
            :rows="5"
            maxlength="200"
          ></Input>
        </FormItem>
      </Form>
      <div class="form_bottom">
        <el-checkbox v-model="accept" label="1"
          >{{ $t('demo.form.privacyAgreement') }}</el-checkbox
        >
        <el-button class="btn">{{ $t('demo.form.submitButton') }}</el-button>
      </div>
    </div>

    <div class="demo_form_mobile hidden-sm-and-up">
      <Form :model="formTopMobile" label-position="top" class="demo_form_item1">
        <FormItem :label="$t('demo.form.serviceLabel')" class="form_item1" required>
          <!-- <Cascader
            :data="selectData"
            v-model="formTopMobile.service"
          ></Cascader> -->
          <el-select v-model="formTopMobile.service" :placeholder="$t('demo.form.servicePlaceholder')">
            <el-option :label="item.label" :value="item.value" v-for="(item,index) in selectData" :key="index"></el-option>
          </el-select>
        </FormItem>
        <FormItem :label="$t('demo.form.nameLabel')" class="form_item1" required>
          <Input
            v-model="formTopMobile.input"
            :placeholder="$t('demo.form.namePlaceholder')"
            size="large"
            style="height: 150px !imporant"
          ></Input>
        </FormItem>
        <FormItem :label="$t('demo.form.phoneLabel')" class="form_item2" required>
          <Input
            v-model="formTopMobile.phone"
            :placeholder="$t('demo.form.phonePlaceholder')"
            size="large"
          ></Input>
        </FormItem>
        <FormItem :label="$t('demo.form.emailLabel')" class="form_item2" required>
          <Input
            v-model="formTopMobile.email"
            :placeholder="$t('demo.form.emailPlaceholder')"
            size="large"
          ></Input>
        </FormItem>
        <FormItem :label="$t('demo.form.codeLabel')" class="form_item2" required>
          <Input
            v-model="formTopMobile.code"
            :placeholder="$t('demo.form.codePlaceholder')"
            search
            :enter-button="$t('demo.form.getCodeButton')"
            size="large"
          ></Input>
        </FormItem>
        <FormItem :label="$t('demo.form.companyLabel')" class="form_item3" required>
          <Input
            v-model="formTopMobile.gongsi"
            :placeholder="$t('demo.form.companyPlaceholder')"
            size="large"
          ></Input>
        </FormItem>
        <FormItem :label="$t('demo.form.positionLabel')" class="form_item3">
          <Input
            v-model="formTopMobile.zhiwu"
            :placeholder="$t('demo.form.positionPlaceholder')"
            size="large"
          ></Input>
        </FormItem>
        <FormItem :label="$t('demo.form.remarksLabel')" class="form_item3">
          <Input
            v-model="formTopMobile.beizhu"
            :placeholder="$t('demo.form.remarksPlaceholder')"
            type="textarea"
            :rows="15"
            maxlength="200"
          ></Input>
        </FormItem>
      </Form>
      <div class="form_bottom">
        <div class="bottom_top">
          <input type="checkbox" id="checkmy" />
          <label for="checkmy" style="font-size: 12px;padding-left:8px;"
            >{{ $t('demo.form.privacyAgreement') }}</label
          >
        </div>
        <el-button class="btn">{{ $t('demo.form.submitButton') }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formTop: {
        input: '',
        service: '',
      },
      formTop2: {
        email: '',
        code: '',
        phone: '',
      },
      formTop3: {
        gongsi: '',
        zhiwu: '',
        beizhu: '',
      },
      formTopMobile: {
        input: '',
        service: [],
        email: '',
        code: '',
        phone: '',
        gongsi: '',
        zhiwu: '',
        beizhu: '',
      },
      accept: '1',

    }
  },
  computed: {
    selectData() {
      return [
        {
          value: 'auditPlatform',
          label: this.$t('demo.form.services.auditPlatform'),
        },
        {
          value: 'complianceManagement',
          label: this.$t('demo.form.services.complianceManagement'),
        },
        {
          value: 'riskAssessment',
          label: this.$t('demo.form.services.riskAssessment'),
        },
        {
          value: 'auditConsulting',
          label: this.$t('demo.form.services.auditConsulting'),
        },
      ]
    }
  },
  methods: {
    onSubmit() {
      console.log('submit!')
    },
  },
}
</script>

<style lang="scss"  >
.demo_wrap {
  padding-top: 150px;
  @media screen and (max-width: 768px) {
    padding: 20px;
  }
  .demo_title_wrap {
    text-align: center;
    @media screen and (max-width: 768px) {
      text-align: left;
    }
    h1 {
      font-size: 32px;
      @media screen and (max-width: 768px) {
        font-size: 28px;
      }
    }
    p {
      font-size: 18px;
      margin-top: 10px;
      @media screen and (max-width: 768px) {
        font-size: 16px;
        margin-top: 10px;
      }
    }
  }
  .demo_form {
    width: 70%;
    margin: 0 auto;
    @media screen and (max-width: 768px) {
      font-size: 16px;
      margin-top: 10px;
    }
    .demo_form_item1 {
      margin-top: 40px;
      .form_item1 {
      }
    }
    .form_bottom {
      position: relative;
      display: flex;
      align-items: center;
      margin-top: 80px;
      .btn {
        background: orange;
        color: #fff;
        border-radius: 20px;
        position: absolute;
        left: 46%;
        transform: translateX(-46%);
      }
    }
  }
  .demo_form_mobile {
    margin-top: 1rem;
    .demo_form_item1 {
      width: 100%;
      .form_item1 {
        margin-top: 1rem;
      }
      .form_item2 {
        margin-top: 1rem;
      }
      .form_item3 {
        margin-top: 1rem;
      }
    }
    .form_bottom {
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      width: 100%;  
      .bottom_top{
        color: #999;
        margin-top: 10PX;
      }
      .btn{
        background: orange;
        color: #fff;
        border-radius: 20PX;
        width: 80PX;
        height: 30PX;
        margin-top: 20PX;
        @media screen and (max-width: 768px){
          width: 90px;
          height: 30px;
          font-size: 16px;
        }
          
      }
    }
  }
}
@media screen and (max-width: 768px){
  .ivu-input,
  .ivu-input-group-prepend {
    height: 40PX !important;
    font-size: 1rem;
  }
  .ivu-form-item-label{
    font-size: 1rem !important;
  }
  .ivu-input-large{
    font-size: 1rem !important;
  }
  .ivu-cascader-menu .ivu-input-search{
    font-size: 1rem !important;
  }
  .ivu-input-group-large>.ivu-input-group-append{
    font-size: 14PX !important;
    padding: 0 10PX !important;
  }
  // .ivu-select-dropdown{
  //   transform: scale(4);
  //   left: 38% !important;
  // }
  .el-input{
    font-size: 1rem !important;
    input{
      height: 40PX;
    }
    span{
      transform: translateY(-40%);
    }
  }
  .el-select{
    width: 100%;
  }
  .el-select-dropdown__item{
    font-size: 14PX;
    padding: 15PX 0;
  }
}
</style>
